import { Component, Input } from '@angular/core';
import {
  IxFilterLookupComponent,
  IxNgComponentsModule,
  IxOverlayDirective,
} from 'ix-ng-components';
import { Popover } from 'primeng/popover';
import { VpoFilterHeaderComponent } from '../header/vpo-filter-header.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lib-filter-lookup',
  templateUrl: './vpo-filter-lookup.component.html',
  styleUrls: ['./vpo-filter-lookup.component.scss'],
  imports: [Popover, VpoFilterHeaderComponent, IxOverlayDirective, NgClass, IxNgComponentsModule],
})
export class VpoFilterLookupComponent extends IxFilterLookupComponent {
  @Input()
  override hasHeaderElement = true;
}
